import styled from 'styled-components';
import { ButtonBase } from '@material-ui/core';

export const CustomTouchable = styled(ButtonBase)``;
